<section>
    <xm-display-card class="split-section">
        <xm-plan-seven-unl 
            [pageData]="planData">
        </xm-plan-seven-unl>
    </xm-display-card>

    <xm-display-card class="split-section">
        <div class="choose-data-options">
            <xm-choose-data-options #XmChooseDataOptions [lines]="lines" [pageData]="planData.chooseDataOptions"
                (submit)="startUpgrade()"></xm-choose-data-options>
        </div>
    </xm-display-card>

    <xm-display-card class="split-section">
        <div class="upgrade-desc">
            <p>{{ planData.upgrade.description }}</p>
        </div>
        <div class="action-button">
            <button class="xm-btn-primary-light" (click)="checkDataOptionsBeforeSubmit()">{{ planData.upgrade.cta}}</button>
        </div>
    </xm-display-card>
</section>
